import React, { Component } from 'react';
import './StatusAnnouncement.css';
import { Panel,Label,Button } from 'react-bootstrap';
import {FormattedDate} from 'react-intl';
import MonitorApi from '../../utils/MonitorApi';
import TagsInput from 'react-tagsinput';
import ChildStatusAnnouncement from '../ChildStatusAnnouncement/ChildStatusAnnouncement.jsx';

var AnnouncementActions  = require('../../actions/AnnouncementActions');
var Translate   = require('react-translate-component');
var issueStates = {investigating:{panelColor:'warning'},monitoring:{panelColor:'info'},resolved:{panelColor:'success'}}

export default class StatusAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.isAuthorized = MonitorApi.isAuthorized();
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleServicesChange = this.handleServicesChange.bind(this);
    this.handleIssueStateChange = this.handleIssueStateChange.bind(this);
    this.saveAnnouncement = this.saveAnnouncement.bind(this);
    this.deleteAnnouncement = this.deleteAnnouncement.bind(this);
    this.editModeAnnouncement = this.editModeAnnouncement.bind(this);
    this.toggleHistory = this.toggleHistory.bind(this);
    this.addChildAnnouncement = this.addChildAnnouncement.bind(this);
    this.checkHistory = this.checkHistory.bind(this);
    this.checkPreviousAnnouncements = this.checkPreviousAnnouncements.bind(this);
    var visualAnnouncement = this.checkHistory(props.announcement);
    if(!visualAnnouncement.services){
      visualAnnouncement.services = [];
    }
    var prevAnnouncements = this.checkPreviousAnnouncements(props.announcement);
    this.state = {announcement:visualAnnouncement,previousAnnouncements:prevAnnouncements,history:false,editMode: props.announcement.id ? false : true};
  }

  checkHistory(announcement) {
    if(announcement !== undefined) {
      if (announcement.history) {
        return announcement.history[announcement.history.length - 1];
      } else {
        return announcement;
      }
    } else {
      return undefined;
    }
  }

  checkPreviousAnnouncements(announcement){
    if(announcement.history){
      var tempAnnouncements = []
      for (var i = 0; i < announcement.history.length -1; i++){
        if(i < announcement.history.length -1){
          tempAnnouncements.push(announcement.history[(announcement.history.length-2)-i]);
        }
      }
      tempAnnouncements.push(announcement);
      return tempAnnouncements;
    } else {
      return undefined;
    }
  }

  componentDidMount() {
    this.checkHistory();
    if(this.state.announcement.id) {
      this.setState({editMode:false});
    }
  }

  saveAnnouncement(){
    if(this.state.announcement.id){
      AnnouncementActions.editAnnouncement(this.state.announcement);
    } else {
      AnnouncementActions.addAnnouncement(this.state.announcement);
    }
    this.editModeAnnouncement();
  }
  editModeAnnouncement(){
    this.setState({editMode:!this.state.editMode});
  }
  toggleHistory(){
    this.setState({history:!this.state.history});
  }

  deleteAnnouncement(){
    AnnouncementActions.deleteAnnouncement(this.state.announcement);
  }

  addChildAnnouncement(){
    var tempAnnouncement = this.state.announcement;
    var child = {title:tempAnnouncement.title, services:tempAnnouncement.services ,date: new Date(), previousId: tempAnnouncement.id};
    this.setState({child: child});
  }

  handleTitleChange(newTitle){
    var tempAnnouncement = this.state.announcement;
    tempAnnouncement.title = newTitle.target.value;
    this.setState({announcement: tempAnnouncement});
  }
  handleMessageChange(newTitle){
    var tempAnnouncement = this.state.announcement;
    tempAnnouncement.message = newTitle.target.value;
    this.setState({announcement: tempAnnouncement});
  }
  handleIssueStateChange(issueState){
    var tempAnnouncement = this.state.announcement;
    if(issueState.target.value === ''){
      delete tempAnnouncement.issueState;
    } else {
      tempAnnouncement.issueState = issueState.target.value;

    }
    this.setState({announcement: tempAnnouncement});
  }
  handleServicesChange(services){
    var tempAnnouncement = this.state.announcement;
    tempAnnouncement.services = services;
    this.setState({announcement: tempAnnouncement});
  }

  renderEditIssueState(){
    var serviceVisual = [];
    Object.keys(issueStates).forEach(function (key) {
      serviceVisual.push(<option key={key} value={key}>{key}</option>);
    });
    return serviceVisual;
  }

  render() {
    return (
      <div className="col-xs-12">
        {
          this.isAuthorized && this.state.editMode ?
            <Panel header={this.state.announcement.title} bsStyle={this.state.announcement.issueState ? issueStates[this.state.announcement.issueState].panelColor : 'default'}>
              {
                this.isAuthorized ?
                  <div className="col-xs-12">
                    {
                      this.state.announcement.id ?
                        <Button onClick={this.deleteAnnouncement}
                                className='centerAll no_style delete_button'><span className="icon_button icon-trash-2"></span></Button>
                        :undefined
                    }
                    <Button onClick={this.editModeAnnouncement}
                            className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                    </Button>
                  </div> : undefined
              }
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.title' />
                </div>
                <div className='col-xs-8'>
                  <input type='text'
                         className='form-control'
                         value={this.state.announcement.title}
                         onChange={this.handleTitleChange} />
                </div>
              </div>
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.message' />
                </div>
                <div className='col-xs-8'>
                  <input type='text'
                         value={this.state.announcement.message}
                         className='form-control'
                         onChange={this.handleMessageChange} />
                </div>
              </div>
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.state' />
                </div>
                <div className='col-xs-8'>
                  <select className="form-control" value={this.state.announcement.issueState} onChange={this.handleIssueStateChange} ref="valid_for">
                    <option value={undefined}> </option>
                    {this.renderEditIssueState()}
                  </select>
                </div>
              </div>
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.services' />
                </div>
                <div className='col-xs-8'>
                  <TagsInput className="form-control tags_react" value={this.state.announcement.services} onChange={this.handleServicesChange} />
                </div>
              </div>
              <div className="col-xs-12 marginToTop">
                {this.state.announcement.id ?
                  <Button onClick={this.addChildAnnouncement}
                          className='no_style save_button col-xs-6 col-xs-offset-2'> <Translate component='span' content={'watchdog.statushistory.announcement.addChild'} />
                  </Button>
                  :<div className="col-xs-4"></div>
                }
                <Button onClick={this.saveAnnouncement}
                        className='no_style save_button col-xs-3 col-xs-offset-1'> <Translate component='span' content={'watchdog.entitySave'} />
                </Button>
              </div>
              {this.state.child ? <ChildStatusAnnouncement announcement={this.state.child} />:undefined}
            </Panel>
            :
            <Panel header={this.state.announcement.title}  bsStyle={this.state.announcement.issueState ? issueStates[this.state.announcement.issueState].panelColor : 'default'}>
              {
                this.isAuthorized ?
                  <div className="col-xs-12">
                    {
                      this.state.announcement.id ?
                        <Button onClick={this.deleteAnnouncement}
                                className='centerAll no_style delete_button'><span className="icon_button icon-trash-2"></span></Button>
                        :undefined
                    }
                    <Button onClick={this.editModeAnnouncement}
                            className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                    </Button>
                  </div> : undefined
              }
              <div className="col-xs-12 row-flex row-flex-wrap">
                <div className="col-xs-3">
                  <div>
                    <div className="col-xs-12 panel_date">
                      <p className="noMargin"><b>
                        <FormattedDate
                          value={this.state.announcement.date}
                          day="numeric"
                          month="long"
                          year="numeric" />
                      </b></p>
                      <p className="noMargin" >{new Date(this.state.announcement.date).toLocaleTimeString()}</p>
                    </div>
                    <div className="col-xs-12 tags_block">
                      { this.state.announcement.services ?
                        this.state.announcement.services.map(function(tag) {
                          return <Label key={tag} bsStyle="default">{tag}</Label>
                        }): undefined }
                      { this.state.announcement.issueState ?
                        <Label key={this.state.announcement.issueState} bsStyle={issueStates[this.state.announcement.issueState].panelColor}>{this.state.announcement.issueState}</Label>
                        :undefined
                      }
                    </div>
                  </div>
                </div>
                <div className="col-xs-9">
                  <p className="announcement_context">
                    {this.state.announcement.message}
                  </p>
                </div>
                {this.state.announcement.previousId ? <a onClick={this.toggleHistory} className=" marginToTop max_width "><Translate component='p' className='sub_title noMargin' content='watchdog.statushistory.announcement.history' /></a>:undefined}

                  {this.state.announcement.previousId && this.state.history ?
                    this.state.previousAnnouncements.map(function(announcement) {
                      return <div className="col-xs-12" key={announcement.id}><div className="col-xs-3"></div><div className="col-xs-9 no_padding"> <ChildStatusAnnouncement announcement={announcement} /></div></div>
                    }): undefined }
              </div>
            </Panel>
        }
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/StatusAnnouncement/StatusAnnouncement.jsx
 **/